import React from 'react';
import { useMemo } from 'react';
import {
  NON_BLOG_DATE_MODIFIED,
  SITE_URL,
  buildPracticeOfferCatalog,
  buildPracticeOrganization,
  buildWebsiteSchema,
} from '../utils/schema';

function normalizePath(pathname = '/') {
  return pathname.length > 1 ? pathname.replace(/\/$/, '') : pathname;
}

export default function SitewideSchema({ location }) {
  const pathname = normalizePath(location?.pathname);
  const schema = useMemo(
    () => {
      const isRichClinicPage = pathname === '/' || pathname === '/get-started';
      const isNonClinicalBridgePage = pathname === '/coaching-and-spiritual-counseling';

      if (isNonClinicalBridgePage) {
        return {
          '@context': 'https://schema.org',
          '@graph': [
            buildWebsiteSchema({
              dateModified: NON_BLOG_DATE_MODIFIED,
              publisher: {
                '@type': 'Organization',
                name: 'Peace Love Wellness',
                url: `${SITE_URL}/`,
              },
              about: undefined,
            }),
          ],
        };
      }

      return {
        '@context': 'https://schema.org',
        '@graph': [
          buildPracticeOrganization(
            isRichClinicPage
              ? {
                  hasOfferCatalog: buildPracticeOfferCatalog(),
                }
              : {},
            {
              includeEmployees: isRichClinicPage,
              includeAvailableServices: isRichClinicPage,
            }
          ),
          buildWebsiteSchema(),
        ],
      };
    },
    [pathname]
  );

  // Rendered in <body> via Layout; JSON-LD is valid anywhere in the document.
  return <script type="application/ld+json">{JSON.stringify(schema)}</script>;
}
